import TileCard2 from "@/components/Shared/TileCard2";
import clsx from "classnames";
import { motion } from "framer-motion";
import useTradewindCoreValues from "hooks/useTradewindCoreValues";
import { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";

import FooterWave2Icon from "@/public/site-assets/svg/footer-wave-2.svg";

export const SimpleTextWithValues = ({
  className,
  heading,
  content,
  items,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  const post = useTradewindCoreValues();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const postsToRender = items && items.length > 0 ? items : post;

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Adjust threshold as needed, make it smaller for more sensitive detection
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(sectionRef.current);

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
      // setIsVisible(!mobileDevice); // Hide motion on mobile devices
    };

    handleResize(); // Call initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section ref={sectionRef} className={clsx(className, styles.root)}>
        <Container>
          {heading && <h3 className={`h3 w-100 text-center`}>{heading}</h3>}
          {content && (
            <div className={`content py-4`} dangerouslySetInnerHTML={{ __html: content }} />
          )}
          {postsToRender?.length >= 1 && (
            <div className="inner-wrapper">
              {postsToRender.map((post, index) => (
                <motion.div
                  className={`column`}
                  initial={{ opacity: 0, y: 50 }}
                  animate={isVisible ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  key={index}
                >
                  <TileCard2 post={post} />
                </motion.div>
              ))}
            </div>
          )}
        </Container>
        {showWave && (
          <div
            className={clsx(
              "footer",
              waveDirection === "down" && "rotate",
              waveColor,
              waveBackground,
            )}
            style={{ marginTop: "-1px" }}
          >
            <FooterWave2Icon />
          </div>
        )}
      </section>
    </>
  );
};

export default SimpleTextWithValues;
